import { render, staticRenderFns } from "./FifthStepHome.vue?vue&type=template&id=89b779ba&"
import script from "./FifthStepHome.vue?vue&type=script&lang=js&"
export * from "./FifthStepHome.vue?vue&type=script&lang=js&"
import style0 from "./FifthStepHome.vue?vue&type=style&index=0&id=89b779ba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports